import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-uniform-section",
  templateUrl: "./uniform-section.component.html",
  styleUrls: ["./uniform-section.component.css"],
})
export class UniformSectionComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
